// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Core__Array from "@rescript/core/src/Core__Array.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Icon$OrcaPaymentPage from "./Icon.bs.js";
import * as RenderIf$OrcaPaymentPage from "./Components/RenderIf.bs.js";
import * as CardUtils$OrcaPaymentPage from "./CardUtils.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "./Utilities/RecoilAtoms.bs.js";
import * as PaymentUtils$OrcaPaymentPage from "./Utilities/PaymentUtils.bs.js";
import * as PaymentMethodCollectUtils$OrcaPaymentPage from "./Utilities/PaymentMethodCollectUtils.bs.js";

function FormViewTabs(props) {
  var renderAddressForm = props.renderAddressForm;
  var __defaultOptionsLimitInTabLayout = props.defaultOptionsLimitInTabLayout;
  var tabsView = props.tabsView;
  var handleSubmit = props.handleSubmit;
  var primaryTheme = props.primaryTheme;
  var availablePaymentMethodTypes = props.availablePaymentMethodTypes;
  var defaultOptionsLimitInTabLayout = __defaultOptionsLimitInTabLayout !== undefined ? __defaultOptionsLimitInTabLayout : PaymentMethodCollectUtils$OrcaPaymentPage.defaultOptionsLimitInTabLayout;
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var payoutDynamicFields = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.payoutDynamicFieldsAtom);
  var formData = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.formDataAtom);
  var match$1 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.paymentMethodTypeAtom);
  var setActivePmt = match$1[1];
  var activePmt = match$1[0];
  var match$2 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.validityDictAtom);
  var setValidityDict = match$2[1];
  var validityDict = match$2[0];
  var paymentMethodListValue = Recoil.useRecoilValue(PaymentUtils$OrcaPaymentPage.paymentMethodListValue);
  var supportedCardBrands = React.useMemo((function () {
          return PaymentUtils$OrcaPaymentPage.getSupportedCardBrands(paymentMethodListValue);
        }), [paymentMethodListValue]);
  var match$3 = React.useState(function () {
        return availablePaymentMethodTypes;
      });
  var setOrderedPmts = match$3[1];
  var orderedPmts = match$3[0];
  var match$4 = React.useState(function () {
        return false;
      });
  var setFormSubmitted = match$4[1];
  var formSubmitted = match$4[0];
  var viewStack = React.useRef([tabsView]);
  var push = function (newState) {
    viewStack.current = Belt_Array.concatMany([
          viewStack.current,
          [newState]
        ]);
  };
  var pop = function () {
    var match = viewStack.current.length;
    if (!(match === 0 || match === 1)) {
      viewStack.current.pop();
      return ;
    }
    
  };
  var get = function () {
    return Core__Option.getOr(viewStack.current[viewStack.current.length - 1 | 0], tabsView);
  };
  var match$5 = React.useState(function () {
        return get();
      });
  var setViewState = match$5[1];
  var view = match$5[0];
  React.useEffect((function () {
          Core__Option.map(availablePaymentMethodTypes[0], (function (pmt) {
                  setActivePmt(function (param) {
                        return pmt;
                      });
                }));
          setOrderedPmts(function (param) {
                return availablePaymentMethodTypes;
              });
        }), [availablePaymentMethodTypes]);
  var handleTabSelection = function (newPmtStr) {
    Core__Option.map(orderedPmts.find(function (pmt) {
              return PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodTypeLabel(pmt) === newPmtStr;
            }), (function (newPmt) {
            if (orderedPmts.indexOf(newPmt) >= defaultOptionsLimitInTabLayout) {
              var ordList = Core__Array.reduceWithIndex(availablePaymentMethodTypes, [], (function (acc, pmt, i) {
                      if (i === (defaultOptionsLimitInTabLayout - 1 | 0)) {
                        acc.push(newPmt);
                      }
                      if (pmt !== newPmt) {
                        acc.push(pmt);
                      }
                      return acc;
                    }));
              setOrderedPmts(function (param) {
                    return ordList;
                  });
            }
            setActivePmt(function (param) {
                  return newPmt;
                });
            return newPmt;
          }));
  };
  var renderSaveButton = function (onClickHandler) {
    return React.createElement("button", {
                className: "min-w-full mt-10 text-lg font-semibold px-2.5 py-1.5 text-white rounded",
                style: {
                  backgroundColor: primaryTheme
                },
                onClick: onClickHandler
              }, localeString.formSaveText);
  };
  var renderPmtTabs = function (activePmt) {
    var key = PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodTypeLabel(activePmt);
    var activeStyles_borderColor = primaryTheme;
    var activeStyles_borderWidth = "2px";
    var activeStyles_color = primaryTheme;
    var activeStyles = {
      borderColor: activeStyles_borderColor,
      borderWidth: activeStyles_borderWidth,
      color: activeStyles_color
    };
    var defaultStyles_borderColor = "#9A9FA8";
    var defaultStyles_borderWidth = "1px";
    var defaultStyles_color = primaryTheme;
    var defaultStyles = {
      borderColor: defaultStyles_borderColor,
      borderWidth: defaultStyles_borderWidth,
      color: defaultStyles_color
    };
    var hiddenTabs = Core__Array.reduceWithIndex(orderedPmts, [], (function (options, pmt, i) {
            if (i >= defaultOptionsLimitInTabLayout) {
              var key = PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodTypeLabel(pmt);
              options.push(React.createElement("option", {
                        key: i.toString(),
                        className: "text-black bg-white hover:bg-gray-100",
                        value: key
                      }, key));
            }
            return options;
          }));
    var visibleTabs = Core__Array.reduceWithIndex(orderedPmts, [], (function (items, pmt, i) {
            if (i < defaultOptionsLimitInTabLayout) {
              var key = PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodTypeLabel(pmt);
              items.push(React.createElement("div", {
                        key: i.toString(),
                        className: "flex w-full items-center rounded border-0 px-2.5 py-1.5 mr-2.5 cursor-pointer hover:bg-jp-gray-50",
                        style: key === PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodTypeLabel(activePmt) ? activeStyles : defaultStyles,
                        onClick: (function (param) {
                            handleTabSelection(key);
                          })
                      }, PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodTypeIcon(pmt), React.createElement("div", {
                            className: "ml-2.5"
                          }, key)));
            }
            return items;
          }));
    return React.createElement("div", {
                className: "flex flex-row w-full"
              }, visibleTabs, React.createElement(RenderIf$OrcaPaymentPage.make, {
                    condition: orderedPmts.length > defaultOptionsLimitInTabLayout,
                    children: React.createElement("div", {
                          className: "relative"
                        }, React.createElement(Icon$OrcaPaymentPage.make, {
                              name: "arrow-down",
                              size: 10,
                              className: "absolute z-10 pointer translate-x-2.5 translate-y-3.5 pointer-events-none"
                            }), React.createElement("select", {
                              className: "h-full relative rounded border border-solid border-jp-gray-700 py-1.5 cursor-pointer bg-white text-transparent w-8 hover:bg-jp-gray-50",
                              value: key,
                              onChange: (function (ev) {
                                  handleTabSelection(ev.target.value);
                                })
                            }, React.createElement("option", {
                                  key: key,
                                  disabled: true,
                                  value: key
                                }, key), hiddenTabs))
                  }));
  };
  var renderInfoTemplate = function (label, value, uniqueKey) {
    return React.createElement("div", {
                key: uniqueKey,
                className: "flex flex-row items-center"
              }, React.createElement("div", {
                    className: "w-4/10 text-jp-gray-800 text-sm min-w-40 text-end"
                  }, label), React.createElement("div", {
                    className: "mx-2.5 h-4 w-0.5 bg-jp-gray-300"
                  }, ""), React.createElement("div", {
                    className: "w-6/10 text-sm min-w-40"
                  }, value));
  };
  var tmp;
  if (typeof view !== "object") {
    var contentHeaderClasses = "text-xl lg:text-2xl font-semibold mt-5";
    var key = PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodTypeLabel(activePmt);
    var onSaveHandler = function () {
      var match = Core__Option.getOr(Core__Option.map(payoutDynamicFields.address, (function (addressFields) {
                  return Core__Array.reduce(addressFields, [
                              {},
                              true
                            ], (function (param, field) {
                                var fieldValidity = param[0];
                                var key = PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldKey({
                                      TAG: "BillingAddress",
                                      _0: field.fieldType
                                    });
                                var value = Core__Option.getOr(formData[key], "");
                                var validity = PaymentMethodCollectUtils$OrcaPaymentPage.calculateValidity({
                                      TAG: "BillingAddress",
                                      _0: field.fieldType
                                    }, value, "", false);
                                fieldValidity[key] = validity;
                                return [
                                        fieldValidity,
                                        param[1] && Caml_obj.notequal(validity, false)
                                      ];
                              }));
                })), [
            Object.assign({}, validityDict),
            true
          ]);
      var match$1 = Core__Array.reduce(payoutDynamicFields.payoutMethodData, [
            match[0],
            match[1]
          ], (function (param, field) {
              var fieldValidity = param[0];
              var key = PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldKey({
                    TAG: "PayoutMethodData",
                    _0: field.fieldType
                  });
              var value = Core__Option.getOr(formData[key], "");
              var validCardBrand = CardUtils$OrcaPaymentPage.getFirstValidCardSchemeFromPML(value, Core__Option.getOr(supportedCardBrands, []));
              var newCardBrand = validCardBrand !== undefined ? validCardBrand : CardUtils$OrcaPaymentPage.getCardBrand(value);
              var validity = PaymentMethodCollectUtils$OrcaPaymentPage.calculateValidity({
                    TAG: "PayoutMethodData",
                    _0: field.fieldType
                  }, value, newCardBrand, false);
              fieldValidity[key] = validity;
              return [
                      fieldValidity,
                      param[1] && Caml_obj.notequal(validity, false)
                    ];
            }));
      var fieldValidity = match$1[0];
      setValidityDict(function (param) {
            return fieldValidity;
          });
      if (match$1[1]) {
        Core__Option.map(PaymentMethodCollectUtils$OrcaPaymentPage.formPaymentMethodData(formData, fieldValidity, payoutDynamicFields), (function (pmd) {
                var view = {
                  TAG: "FinalizeView",
                  _0: [
                    activePmt,
                    pmd
                  ]
                };
                setViewState(function (param) {
                      push(view);
                      return view;
                    });
              }));
        return ;
      }
      
    };
    var tmp$1;
    switch (activePmt.TAG) {
      case "Card" :
          tmp$1 = localeString.formHeaderEnterCardText;
          break;
      case "BankRedirect" :
      case "BankTransfer" :
          tmp$1 = localeString.formHeaderBankText(key);
          break;
      case "Wallet" :
          tmp$1 = localeString.formHeaderWalletText(key);
          break;
      
    }
    tmp = React.createElement("div", undefined, renderPmtTabs(activePmt), React.createElement("div", {
              className: contentHeaderClasses
            }, tmp$1), props.renderPayoutMethodForm(payoutDynamicFields.payoutMethodData), Core__Option.getOr(Core__Option.map(payoutDynamicFields.address, (function (addressFields) {
                    var fieldsToCollect = addressFields.filter(function (addressField) {
                          return addressField.value === undefined;
                        });
                    if (fieldsToCollect.length <= 0) {
                      return null;
                    }
                    var formFields = renderAddressForm(addressFields);
                    return React.createElement(React.Fragment, {}, React.createElement("div", {
                                    className: "mb-2.5 " + contentHeaderClasses
                                  }, localeString.billingDetailsText), formFields);
                  })), null), renderSaveButton(function (param) {
              onSaveHandler();
            }));
  } else {
    var match$6 = view._0;
    var formFields = match$6[1];
    var pmt = match$6[0];
    var pm = PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodForPmt(pmt);
    tmp = React.createElement("div", undefined, React.createElement("div", {
              className: "flex flex-col"
            }, React.createElement("div", {
                  className: "flex flex-row items-center mb-2.5 text-xl font-semibold"
                }, React.createElement("img", {
                      className: "h-6 w-auto",
                      alt: "",
                      src: "merchantLogo"
                    }), React.createElement("div", {
                      className: "ml-1.5"
                    }, localeString.formHeaderReviewTabLayoutText(PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodTypeLabel(pmt)))), formFields.map(function (field, i) {
                  var value = field[1];
                  var field$1 = field[0];
                  if (field$1.TAG === "BillingAddress") {
                    return null;
                  }
                  var fieldType = field$1._0.fieldType;
                  if (typeof fieldType !== "object") {
                    return renderInfoTemplate(PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldLabel({
                                    TAG: "PayoutMethodData",
                                    _0: fieldType
                                  }, localeString), value, i.toString());
                  }
                  if (fieldType._0 !== "CardExpMonth") {
                    return null;
                  }
                  var expiryYear = Core__Option.getOr(Core__Option.flatMap(formData[PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldKey({
                                    TAG: "PayoutMethodData",
                                    _0: {
                                      TAG: "CardExpDate",
                                      _0: "CardExpYear"
                                    }
                                  })], (function (value) {
                              return Core__Option.map(value.split("/")[1], (function (year) {
                                            return "20" + year.trim();
                                          }));
                            })), "");
                  var expiryValue = value + " / " + expiryYear;
                  return renderInfoTemplate(PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldLabel({
                                  TAG: "PayoutMethodData",
                                  _0: {
                                    TAG: "CardExpDate",
                                    _0: "CardExpMonth"
                                  }
                                }, localeString), expiryValue, i.toString());
                })), React.createElement("div", {
              className: "flex flex-row items-center min-w-full my-5 px-2.5 py-1.5 text-xs border border-solid border-blue-200 rounded bg-blue-50"
            }, React.createElement("img", {
                  className: "h-3 w-auto mr-1.5",
                  alt: "",
                  src: "merchantLogo"
                }), localeString.formFundsCreditInfoText(PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodLabel(pm).toLowerCase())), React.createElement("div", {
              className: "flex my-5 text-lg font-semibold w-full"
            }, React.createElement("button", {
                  className: "w-full px-2.5 py-1.5 rounded border border-solid",
                  style: {
                    borderColor: primaryTheme,
                    color: primaryTheme
                  },
                  disabled: formSubmitted,
                  onClick: (function (param) {
                      var countOpt;
                      var count = countOpt !== undefined ? countOpt : 1;
                      setViewState(function (param) {
                            for(var _for = 1; _for <= count; ++_for){
                              pop();
                            }
                            return get();
                          });
                    })
                }, localeString.formEditText), React.createElement("button", {
                  className: "w-full px-2.5 py-1.5 text-white rounded ml-2.5",
                  style: {
                    backgroundColor: primaryTheme
                  },
                  disabled: formSubmitted,
                  onClick: (function (param) {
                      setFormSubmitted(function (param) {
                            return true;
                          });
                      handleSubmit([
                            pmt,
                            formFields
                          ]);
                    })
                }, formSubmitted ? localeString.formSubmittingText : localeString.formSubmitText)));
  }
  return React.createElement("div", {
              className: "w-full max-w-[520px]"
            }, tmp);
}

var make = FormViewTabs;

var $$default = FormViewTabs;

export {
  make ,
  $$default as default,
}
/* react Not a pure module */
